var NumericSortOrder = /* @__PURE__ */ ((NumericSortOrder2) => {
  NumericSortOrder2[NumericSortOrder2["ASC"] = 0] = "ASC";
  NumericSortOrder2[NumericSortOrder2["DESC"] = 1] = "DESC";
  NumericSortOrder2[NumericSortOrder2["ON_REFERENCE_ASCENDING"] = 2] = "ON_REFERENCE_ASCENDING";
  NumericSortOrder2[NumericSortOrder2["ON_REFERENCE_DESCENDING"] = 3] = "ON_REFERENCE_DESCENDING";
  return NumericSortOrder2;
})(NumericSortOrder || {});
var ArdoqIconCategory = /* @__PURE__ */ ((ArdoqIconCategory2) => {
  ArdoqIconCategory2["Ardoq"] = "Ardoq";
  ArdoqIconCategory2["BPMN"] = "BPMN";
  ArdoqIconCategory2["ArchiMate"] = "ArchiMate";
  ArdoqIconCategory2["FontAwesome"] = "Font Awesome";
  ArdoqIconCategory2["UseCase"] = "Use Case";
  return ArdoqIconCategory2;
})(ArdoqIconCategory || {});
var CollectionView = /* @__PURE__ */ ((CollectionView2) => {
  CollectionView2["DEFAULT_VIEW"] = "default";
  CollectionView2["BASE_VIEW"] = "base-view";
  CollectionView2["WITH_PLACEHOLDERS"] = "with-placeholders";
  return CollectionView2;
})(CollectionView || {});
var DynamicFilterSelectState = /* @__PURE__ */ ((DynamicFilterSelectState2) => {
  DynamicFilterSelectState2[DynamicFilterSelectState2["ACTIVE"] = 0] = "ACTIVE";
  DynamicFilterSelectState2[DynamicFilterSelectState2["INACTIVE"] = 1] = "INACTIVE";
  DynamicFilterSelectState2[DynamicFilterSelectState2["LOADING"] = 2] = "LOADING";
  return DynamicFilterSelectState2;
})(DynamicFilterSelectState || {});
var DiffType = /* @__PURE__ */ ((DiffType2) => {
  DiffType2["NONE"] = "none";
  DiffType2["PLACEHOLDER"] = "placeholder";
  DiffType2["ADDED"] = "added";
  DiffType2["REMOVED"] = "removed";
  DiffType2["CHANGED"] = "changed";
  DiffType2["UNCHANGED"] = "unchanged";
  return DiffType2;
})(DiffType || {});
var ConditionalFormattingState = /* @__PURE__ */ ((ConditionalFormattingState2) => {
  ConditionalFormattingState2[ConditionalFormattingState2["NORMAL"] = 0] = "NORMAL";
  ConditionalFormattingState2[ConditionalFormattingState2["FORMATTED"] = 1] = "FORMATTED";
  ConditionalFormattingState2[ConditionalFormattingState2["DIM"] = 2] = "DIM";
  return ConditionalFormattingState2;
})(ConditionalFormattingState || {});
const TAGS_FIELD_NAME = "tags";
var ReferenceLabelSource = /* @__PURE__ */ ((ReferenceLabelSource2) => {
  ReferenceLabelSource2["NONE"] = "none";
  ReferenceLabelSource2["DISPLAY_TEXT"] = "displayText";
  ReferenceLabelSource2["REFERENCE_TYPE"] = "refType";
  ReferenceLabelSource2["DISPLAY_TEXT_OR_REFERENCE_TYPE"] = "displayTextOrRefType";
  return ReferenceLabelSource2;
})(ReferenceLabelSource || {});
var ComponentLabelSource = /* @__PURE__ */ ((ComponentLabelSource2) => {
  ComponentLabelSource2["NONE"] = "none";
  ComponentLabelSource2["NAME"] = "name";
  ComponentLabelSource2["TYPE"] = "type";
  return ComponentLabelSource2;
})(ComponentLabelSource || {});
export {
  ArdoqIconCategory,
  CollectionView,
  ComponentLabelSource,
  ConditionalFormattingState,
  DiffType,
  DynamicFilterSelectState,
  NumericSortOrder,
  ReferenceLabelSource,
  TAGS_FIELD_NAME
};
//# sourceMappingURL=index.js.map
